
import ReactHTMLTableToExcel from "react-html-table-to-excel"
import moment from 'moment'
import { useSearchParams } from "react-router-dom"
import { useEffect, useState } from "react"

export const WaterQualityChlorineServiceExportData = (props) => {
    const { ExcelData, name, searchName, RoleID, FromDate, ToDate, WardName } = props

    const [maxPressureLength, setMaxPressureLength] = useState(0);

    useEffect(() => {
        if (ExcelData && ExcelData.length > 0) {
            const result = findMaxPressureLength();
            setMaxPressureLength(result);
        }
    }, [ExcelData])


    const findMaxPressureLength = () => {
        return ExcelData
            .flatMap(item => item?.pressure || [])
            .reduce((maxLength, pressureItem) => {
                const currentLength = pressureItem?.pressure?.length || 0;
                return Math.max(maxLength, currentLength);
            }, 0);
    };


    const [searchParams] = useSearchParams()
    let DashProjectTypeId = searchParams.get('DashProjectTypeId')

    return (
        <div style={{ display: 'inline', marginLeft: '0px' }}>
            <ReactHTMLTableToExcel
                id="test-table-xls-button"
                table="table-to-WaterQualityChlorine"
                className="btn btn-primary float-end download-table-xls-button float-end btn btn-export btn-md mr-1 mb-1 ml-1"
                filename={name}
                sheet={name}
                buttonText="Export"
                style={{ borderColor: 'black' }}
            />


            <table id="table-to-WaterQualityChlorine" style={{ display: 'none', width: '49%', border: "1px solid black" }}>

                <h5><span>&emsp;</span></h5>

                <tr>
                    <th colSpan={16} style={{ textAlign: 'center', fontSize: 16, border: "1px solid black" }}>Navi Mumbai Municipal Corporation</th>
                </tr>
                {/* <tr>
                    <th colSpan={16} style={{ textAlign: 'center', fontSize: 16, border: "1px solid black" }}>WATER SUPPLY DEPARTMENT</th>
                </tr> */}

                <tr>
                    <th colSpan={16} style={{ textAlign: 'center', fontSize: 16, border: "1px solid black" }}>Water Quality-Chlorine</th>
                </tr>

                <tr>
                    <th colSpan={16} style={{ textAlign: 'center', fontSize: 16, border: "1px solid black" }}>Report Name: {name}</th>
                </tr>

                <tr>
                    <th colSpan={16} style={{ textAlign: 'center', fontSize: 16, border: "1px solid black" }}>From Date:- {FromDate ? moment(FromDate).format('DD-MM-YYYY') : ''} </th>
                </tr>
                <tr>
                    <th colSpan={16} style={{ textAlign: 'center', fontSize: 16, border: "1px solid black" }}>To Date:- {ToDate ? moment(ToDate).format('DD-MM-YYYY') : ''} </th>
                </tr>

                <thead>
                    <tr style={{ backgroundColor: '#254462', color: "#fff", border: '1px solid white', borderTop: "1px solid black" }}>
                        <th rowSpan={2} className="sr_no_col" style={{ borderLeft: "1px solid black" }}>Sr No.</th>
                        <th rowSpan={2} >Reading Time</th>

                        {
                            ExcelData && ExcelData.length > 0 && ExcelData.map((s) => {
                                return (
                                    s.data_Junction.map(q => {
                                        return (
                                            <>
                                                <th colSpan={2}>{q.junctionDetails}</th>
                                            </>
                                        )
                                    })

                                )
                            })
                        }

                    </tr>

                    <tr style={{ backgroundColor: '#254462', color: "#fff", border: '1px solid white', borderTop: "1px solid white" }}>


                        {
                            ExcelData && ExcelData.length > 0 && ExcelData.map((sb) => {
                                return (
                                    sb.data_Junction.map(q => {
                                        return (
                                            <>
                                                <th >In</th>
                                                <th >Out</th>
                                            </>
                                        )
                                    })

                                )
                            })
                        }

                    </tr>

                </thead>
                <tbody>
                    {
                        ExcelData && ExcelData.length > 0 && ExcelData.map((item, d) => {
                            return (
                                item.pressure && item.pressure.map((m, i) => {
                                    return (
                                        <>

                                            <tr style={{ width: '100%' }}>
                                                <td style={{ textAlign: "center", border: '1px solid black' }}>{i + 1}</td>
                                                <td style={{ textAlign: "center", border: '1px solid black' }}>{m.readingTime}</td>

                                                {
                                                    Array.from({ length: maxPressureLength }, (_, index) => {
                                                        const n = m.pressure?.[index] || {};
                                                        return (
                                                            <>
                                                                <td style={{ textAlign: "right", border: '1px solid black' }}>{n.inletChlorine || '0'}</td>
                                                                <td style={{ textAlign: "right", border: '1px solid black' }}>{n.outChlorine || '0'}</td>
                                                            </>
                                                        )
                                                    })
                                                }

                                                {/* {
                                                    m.pressure.map(n => {
                                                        return (
                                                            <>
                                                                <td style={{ textAlign: "right", border: '1px solid black' }}>{n.inletChlorine ? n.inletChlorine : '0'}</td>
                                                                <td style={{ textAlign: "right", border: '1px solid black' }}>{n.outChlorine ? n.outChlorine : '0'}</td>
                                                            </>
                                                        )
                                                    })
                                                } */}
                                            </tr>
                                        </>
                                    )
                                })
                            )
                        })
                    }
                </tbody>

            </table>
        </div>
    )
}